import React from "react";
import { Form } from 'react-bootstrap'
import QuoteStepBase from '../components/QuoteStepBase';
import ButtonContinue from "../components/ButtonContinue";
import { IQuoteStepState, IQuoteStepComponentProps } from "../components/interfaces";
import QuoteStep from "./QuoteStepLayout";
import { ValidatableForm } from "../components/ValidatableForm";
import { ValidatableFormGroup } from "../components/ValidatableFormGroup";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import { PATHS, QUOTE_STEPS, COMPONENTS } from "../AppConstants";
import { IAppState } from "../state/interfaces";
import { IContactInfo } from "../classes/Domain";
import Utilities from "../classes/Utilities";
import { quoteStepChanged, updateContactInfo } from "../state/appActions";
import { Rifm } from 'rifm';

interface IState extends IQuoteStepState {
    email: string,
    phone: string,
    emailSubscription: boolean,
    phoneMessagesSubscription: boolean;
}

interface IContactInfoProps extends IQuoteStepComponentProps {
    contactInfo: IContactInfo
}

class ContactInfo extends QuoteStepBase<IContactInfoProps, IState> {

    constructor(props: IContactInfoProps) {
        super(props);
        this.next = this.next.bind(this);

        this.state = {
            email: "",
            phone: "",
            emailSubscription: true,
            phoneMessagesSubscription: true,
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const contactInfo = nextProps.contactInfo;
            nextProps.meta.propsSource = "";

            if (!contactInfo) return prevState;

            return {
                ...prevState,
                email: contactInfo.email,
                phone: contactInfo.phone,
                emailSubscription: contactInfo.emailSubscription,
                phoneMessagesSubscription: contactInfo.phoneMessagesSubscription
            };
        }

        return prevState;
    }

    next(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {
            const updatedContactInfo = {
                ...this.props.contactInfo,
                email: this.state.email,
                phone: this.state.phone,
                emailSubscription: this.state.emailSubscription,
                phoneMessagesSubscription: this.state.phoneMessagesSubscription
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, contactInfo: updatedContactInfo })
                .then(() => this.props.history.push(PATHS.COVERAGES),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    handleEmailSubscription(evt: any) {
        this.setState({ ...this.state, emailSubscription: evt.target.checked });
    }

    handlePhoneMessagesSubscription(evt: any) {
        this.setState({ ...this.state, phoneMessagesSubscription: evt.target.checked });
    }

    render() {
        return (
            <QuoteStep id="contactInfo">
                <div className="titleArea"><h5>CONTACT INFO</h5></div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <ValidatableFormGroup
                        label="Email address (*Optional)"
                        value={this.state.email}
                        placeholder="Enter email"
                        validated={null !== this.state.errors}
                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "email")}
                        onChange={(e) => { this.setStateValue(e.target.value, "email") }} />

                    {
                        //<Form.Group className="col">
                        //    <Form.Check type="checkbox" id="emailSubscription">
                        //        <Form.Check.Input
                        //            type="checkbox"
                        //            checked={this.state.emailSubscription}
                        //            onChange={this.handleEmailSubscription}
                        //            isValid />
                        //        <Form.Check.Label className="lable-grey">Yes, I would like to receive occasional emails with price alerts and updates.</Form.Check.Label>
                        //    </Form.Check>
                        //</Form.Group>
                    }

                    <Rifm
                        accept={/\d/g}
                        mask={10 <= this.state.phone.length}
                        format={Utilities.formatPhone}
                        value={this.state.phone}
                        onChange={(v) => { this.setStateValue(v, "phone") }}>
                        {({ value, onChange }) => (
                            <ValidatableFormGroup
                                label="Phone number (*Optional)"
                                placeholder="(___)___-____"
                                value={value}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "phone")}
                                onChange={(e) => { onChange(e) }}
                                pattern="[0-9]*"
                                inputmode="numeric" />
                        )}
                    </Rifm>

                    {
                        //<Form.Group className="col">
                        //    <Form.Check type="checkbox" id="phoneMessagesSubscription">
                        //        <Form.Check.Input
                        //            type="checkbox"
                        //            checked={this.state.phoneMessagesSubscription}
                        //            onChange={this.handlePhoneMessagesSubscription}
                        //            isValid />
                        //        <Form.Check.Label className="lable-grey">Yes, I would like to receive reminders about my auto insurance quote via text message.</Form.Check.Label>
                        //    </Form.Check>
                        //</Form.Group>
                    }

                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        quoteUid: state.quoteUid,
        contactInfo: state.contactInfo,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE }
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(QUOTE_STEPS.CONTACT_INFO)),
        updateAppState: (update) => dispatch(updateContactInfo(update.quoteUid, update.contactInfo, QUOTE_STEPS.CONTACT_INFO))
    };
};

export default connect(mapProps, mapDispatch)(ContactInfo);
